import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthInterceptor } from './interceptors/auth.interceptor';

import { AppComponent } from './app.component';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { HomeComponent } from './pages/home/home.component';
import { FlaggedContactsComponent } from './pages/flagged-contacts/flagged-contacts.component';
import { ExclusionsComponent } from './pages/exclusions/exclusions.component';
import { AuditRecordsComponent } from './pages/audit-records/audit-records.component';
import { AssociationSelectionComponent } from './pages/association-selection/association-selection.component';
import { AuditRecordDetailComponent } from './pages/audit-record-detail/audit-record-detail.component';
import { AuthCallbackComponent } from './pages/auth-callback/auth-callback.component';
import { NotAuthorizedComponent } from './pages/not-authorized/not-authorized.component';
import { AuthGuard } from './guards/auth.guard';
import { AgVantisUserGuard } from './guards/agvantis-user.guard';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { 
    path: 'auth/callback', 
    component: AuthCallbackComponent
  },
  { 
    path: 'not-authorized', 
    component: NotAuthorizedComponent
  },
  { 
    path: 'flagged-contacts', 
    component: FlaggedContactsComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'exclusions', 
    component: ExclusionsComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'audit-records', 
    component: AuditRecordsComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'audit-record-detail', 
    component: AuditRecordDetailComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'association-selection', 
    component: AssociationSelectionComponent,
    canActivate: [AgVantisUserGuard]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    NavMenuComponent,
    HomeComponent,
    FlaggedContactsComponent,
    ExclusionsComponent,
    AuditRecordsComponent,
    AssociationSelectionComponent,
    AuditRecordDetailComponent,
    AuthCallbackComponent,
    NotAuthorizedComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

